var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverLeague(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4655_315159)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M25.353 49.9983C39.1601 49.9983 50.353 38.9596 50.353 25.3426C50.353 11.7257 39.1601 0.687012 25.353 0.687012C11.5459 0.687012 0.352997 11.7257 0.352997 25.3426C0.352997 38.9596 11.5459 49.9983 25.353 49.9983Z",
    fill: "url(#paint0_radial_4655_315159)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.467 8.18701C14.5954 8.18701 5.78534 16.8758 5.78534 27.591C5.78534 38.3062 14.5954 47.0016 25.467 47.0016C36.3387 47.0016 45.142 38.3128 45.142 27.591C45.142 16.8691 36.3319 8.18701 25.467 8.18701ZM25.467 42.4784C17.127 42.4784 10.3717 35.8162 10.3717 27.591C10.3717 19.3658 17.127 12.7102 25.467 12.7102C33.8071 12.7102 40.5557 19.3724 40.5557 27.591C40.5557 35.8095 33.8004 42.4784 25.467 42.4784Z",
    fill: "url(#paint1_linear_4655_315159)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4685 11.3618C16.3764 11.3618 9.0033 18.6333 9.0033 27.5936C9.0033 36.5539 16.3764 43.832 25.4685 43.832C34.5606 43.832 41.927 36.5605 41.927 27.5936C41.927 18.6267 34.5539 11.3618 25.4685 11.3618ZM25.4685 42.481C17.1285 42.481 10.3732 35.8188 10.3732 27.5936C10.3732 19.3684 17.1285 12.7128 25.4685 12.7128C33.8086 12.7128 40.5571 19.3751 40.5571 27.5936C40.5571 35.8121 33.8018 42.481 25.4685 42.481Z",
    fill: "url(#paint2_linear_4655_315159)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58445 15.5249C9.37628 16.4321 11.2901 17.9487 11.6258 18.1275C11.9616 18.3129 16.4002 11.0348 25.4655 11.3659C34.5307 11.6904 39.3588 18.1407 39.7147 18.4056C40.0706 18.6706 42.3537 18.1341 42.3537 18.1341C42.3537 18.1341 37.5122 7.75664 25.7609 8.0679C14.0096 8.38578 9.58445 15.5249 9.58445 15.5249Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1598 12.0351C29.7502 11.9291 32.8458 9.29999 33.0808 9.40595C33.3159 9.51191 37.2374 11.4854 37.9962 12.3728C38.755 13.2603 37.6605 16.3397 37.6538 16.3331C37.6471 16.3265 35.3102 13.3463 30.1531 12.0351H30.1598Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1706 19.5362C11.1706 19.5362 16.8515 12.7084 25.4668 12.7084C34.0822 12.7084 39.9645 19.9005 39.9645 19.9005C39.9645 19.9005 34.8276 11.3574 25.7019 11.3574C16.5761 11.3574 11.1706 19.5362 11.1706 19.5362Z",
    fill: "#232323"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.12266 29.5537C9.12266 29.5537 7.73937 23.6067 11.3453 19.2358C11.3453 19.2358 8.96821 22.759 9.12266 29.5537Z",
    fill: "#7F807E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.501 15.197C36.3869 15.1042 37.4613 14.8393 37.7164 15.0645C37.9716 15.2897 37.7164 16.389 37.7164 16.389C37.7164 16.389 36.6555 15.3294 36.501 15.197Z",
    fill: "#80807F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1716 17.3389C10.5538 17.2528 9.77485 15.6568 10.8224 14.1601C11.8699 12.6634 14.4485 11.4382 15.5632 11.1468C16.6846 10.8554 15.5766 14.1005 14.5895 15.4117C13.6024 16.723 11.1783 17.3389 11.1783 17.3389H11.1716Z",
    fill: "#BDBEBC"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57684 23.543L7.26285 23.9934V26.0199L8.30368 26.298C8.30368 26.298 7.70604 11.9934 25.4605 10.053V0C25.4605 0 21.1495 0.311258 17.6375 2.03311L18.3359 6.04636L17.2951 6.35762L16.6034 3.98676C16.6034 3.98676 11.1374 5.66887 7.42401 11.7483L8.34397 13.1126C8.34397 13.1126 4.92602 17.9272 4.57684 23.543Z",
    fill: "url(#paint3_linear_4655_315159)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.631 2.03369L17.0199 3.79528L17.631 6.25886L18.0943 6.11978L19.3836 9.51051L17.631 2.03369Z",
    fill: "#1B1B1B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.41553 11.7456L8.01988 13.7059L8.23476 13.3085L11.3908 15.984L7.41553 11.7456Z",
    fill: "#1B1B1B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57684 23.5425L5.91313 25.059L5.95342 24.7345L7.25613 25.059V23.9994L4.57684 23.5425Z",
    fill: "#1B1B1B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6283 12.1128L15.9025 7.84131C15.9025 7.84131 13.2501 9.00025 11.3967 11.3645L13.9551 14.3976L17.635 12.1128H17.6283Z",
    fill: "url(#paint4_linear_4655_315159)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4522 1.58496C25.4522 1.58496 22.1349 2.03529 19.8586 2.99556L20.98 8.50549L25.4522 8.05516V1.58496Z",
    fill: "url(#paint5_linear_4655_315159)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9574 11.246C11.9574 11.246 13.6563 9.51095 15.6641 8.72949C15.6641 8.72949 17.1817 11.5772 17.1951 11.9745C17.1951 11.9745 15.5432 13.2328 14.1263 13.8686L11.9574 11.246Z",
    fill: "url(#paint6_linear_4655_315159)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34438 15.3037L10.1306 16.6083C10.1306 16.6083 8.40481 19.4097 7.42442 22.8931L5.75238 22.6282C5.75238 22.6282 6.03441 17.9262 8.34438 15.3037Z",
    fill: "url(#paint7_linear_4655_315159)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81537 16.7162L8.43208 15.7295C8.43208 15.7295 6.61231 17.948 6.03482 22.1997L7.41811 22.405C7.41811 22.405 8.39179 19.5109 9.81537 16.7162Z",
    fill: "#1B1B1B"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4523 2.03369C25.4523 2.03369 22.1955 2.43766 20.4899 3.29197C20.4899 3.29197 21.2084 8.17939 21.3293 8.19263C21.4434 8.20588 25.4523 7.84164 25.4523 7.84164V2.03369Z",
    fill: "#1B1B1B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3304 23.5426L43.6444 23.9929V26.0194L42.6035 26.2975C42.6035 26.2975 43.2012 11.9929 25.4467 10.0525V-0.000488281C25.4467 -0.000488281 29.7577 0.31077 33.2697 2.03262L32.5713 6.04587L33.6121 6.35713L34.3038 3.98627C34.3038 3.98627 39.7698 5.66839 43.4832 11.7479L42.5633 13.1121C42.5633 13.1121 45.9812 17.9267 46.3304 23.5426Z",
    fill: "url(#paint8_linear_4655_315159)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2768 2.03369L33.8879 3.79528L33.2768 6.25886L32.8135 6.11978L31.5242 9.51051L33.2768 2.03369Z",
    fill: "#1B1B1B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4878 11.7456L42.8834 13.7059L42.6753 13.3085L39.5125 15.984L43.4878 11.7456Z",
    fill: "#1B1B1B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3285 23.5425L44.9989 25.059L44.9519 24.7345L43.6492 25.059V23.9994L46.3285 23.5425Z",
    fill: "#1B1B1B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2765 12.1128L35.0023 7.84131C35.0023 7.84131 37.6547 9.00025 39.5081 11.3645L36.9496 14.3976L33.2698 12.1128H33.2765Z",
    fill: "url(#paint9_linear_4655_315159)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4534 1.58496C25.4534 1.58496 28.7706 2.03529 31.047 2.99556L29.9256 8.50549L25.4534 8.05516V1.58496Z",
    fill: "url(#paint10_linear_4655_315159)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9504 11.246C38.9504 11.246 37.2515 9.51095 35.2437 8.72949C35.2437 8.72949 33.7261 11.5772 33.7127 11.9745C33.7127 11.9745 35.3646 13.2328 36.7814 13.8686L38.9504 11.246Z",
    fill: "url(#paint11_linear_4655_315159)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5638 15.3037L40.7776 16.6083C40.7776 16.6083 42.5033 19.4097 43.4837 22.8931L45.1557 22.6282C45.1557 22.6282 44.8737 17.9262 42.5638 15.3037Z",
    fill: "url(#paint12_linear_4655_315159)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0909 16.7158L42.4742 15.729C42.4742 15.729 44.2939 17.9475 44.8714 22.1992L43.4881 22.4045C43.4881 22.4045 42.5145 19.5105 41.0909 16.7158Z",
    fill: "#1B1B1B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4534 2.03369C25.4534 2.03369 28.7102 2.43766 30.4158 3.29197C30.4158 3.29197 29.6973 8.17939 29.5764 8.19263C29.4623 8.20588 25.4534 7.84164 25.4534 7.84164V2.03369Z",
    fill: "#1B1B1B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5959 3.99316L18.0933 6.11899L17.2875 6.36402L16.5959 3.99316Z",
    fill: "#7F807E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2833 4.1001L32.8127 6.11997L33.6185 6.365L34.2833 4.1001Z",
    fill: "#7F807E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5028 25.0558L41.0932 30.3737L43.9538 36.0757L46.3309 31.5128L43.9807 28.1618L48.0097 26.3009L47.3516 21.5459L41.5028 25.0558Z",
    fill: "url(#paint13_linear_4655_315159)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.008 26.3013L45.1004 28.8112V28.3476L43.979 28.1622L48.008 26.3013Z",
    fill: "#FDFEFB"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9535 36.0726L42.362 37.5494L42.9731 36.2514L41.5025 31.5494H40.0185L39.5149 30.7812L39.6022 25.2249L41.5025 25.0527L41.0929 30.3706L43.9535 36.0726Z",
    fill: "#1B1B1B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3507 21.5471L46.0615 21.4478L46.142 21.8848L42.4488 24.1762L40.2127 24.4146L39.6016 25.2292L41.502 25.057L47.3507 21.5471Z",
    fill: "#7F807E"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1185 26.9043L46.0508 31.103L44.231 28.5136C44.231 28.5136 45.7956 27.4341 47.1185 26.9043Z",
    fill: "url(#paint14_linear_4655_315159)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5033 25.0519L40.5632 25.138C40.5632 25.138 41.3757 24.4228 42.2016 24.1976C43.0276 23.9724 44.6392 23.1777 44.6392 23.1777L41.51 25.0519H41.5033Z",
    fill: "#7F807E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43233 25.0553L9.84194 30.3732L6.98135 36.0752L4.60423 31.5123L6.95448 28.1613L2.92548 26.3004L3.58355 21.5454L9.43233 25.0553Z",
    fill: "url(#paint15_linear_4655_315159)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92548 26.3013L5.83308 28.8112V28.3476L6.95449 28.1622L2.92548 26.3013Z",
    fill: "#FDFEFB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98206 36.0726L8.58023 37.5494L7.96245 36.2514L9.43304 31.5494H10.9171L11.4207 30.7812L11.3334 25.2249L9.43304 25.0527L9.84265 30.3706L6.98206 36.0726Z",
    fill: "#1B1B1B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58453 21.5471L4.87382 21.4478L4.79324 21.8848L8.48649 24.1762L10.7226 24.4146L11.3337 25.2292L9.43331 25.057L3.58453 21.5471Z",
    fill: "#7F807E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.81879 26.9048L4.88647 31.1035L6.70624 28.5141C6.70624 28.5141 5.14164 27.4346 3.81879 26.9048Z",
    fill: "url(#paint16_linear_4655_315159)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43245 25.0519L10.3726 25.138C10.3726 25.138 9.56004 24.4228 8.73409 24.1976C7.90814 23.9724 6.29654 23.1777 6.29654 23.1777L9.42574 25.0519H9.43245Z",
    fill: "#7F807E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9947 12.1763C33.7865 11.7061 34.0081 11.1829 35.6667 10.9378C37.3186 10.6928 36.9359 12.7855 36.721 13.2623C36.4994 13.7325 34.0014 12.1829 34.0014 12.1829L33.9947 12.1763Z",
    fill: "#DBDCD8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1264 13.7137C13.7235 13.568 13.3004 12.0978 14.6165 10.9388C15.9394 9.7799 16.8661 11.3428 16.8997 11.8527C16.9332 12.3627 14.1264 13.7137 14.1264 13.7137Z",
    fill: "#DBDCD8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91965 11.5373C7.91965 11.5373 10.243 11.0604 12.4456 9.78892C14.6481 8.5174 16.5954 4.45117 16.5954 4.45117C16.5954 4.45117 11.1831 5.96111 7.91965 11.5373Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6983 2.31672C17.6983 2.31672 22.4324 1.52202 25.4609 1.58163C28.4826 1.64123 32.1222 2.72732 32.2699 2.72732C32.4176 2.72732 33.2302 2.26374 33.2302 2.26374C33.2302 2.26374 29.2683 0.137917 25.4609 0.197519C21.6535 0.257122 17.6983 2.3101 17.6983 2.3101V2.31672Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6031 4.10059C34.6031 4.10059 35.3217 6.35224 36.4901 7.67674C37.6585 9.00125 42.6074 11.3655 42.6074 11.3655C42.6074 11.3655 41.9561 7.72972 34.6031 4.10059Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5975 4.45605C16.5975 4.45605 14.6904 5.2044 13.7235 6.15142C12.7565 7.09844 12.5819 9.70771 12.5819 9.70771C12.5819 9.70771 16.1812 5.82692 16.5975 4.45605Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9928 2.27179C17.9928 2.27179 19.497 1.41749 21.6189 0.814838C23.7408 0.212189 25.9635 0.205566 25.9635 0.205566C25.9635 0.205566 25.433 1.01351 23.4387 1.46384C21.4376 1.91418 17.9928 2.26517 17.9928 2.26517V2.27179Z",
    fill: "#BDBEBC"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6031 4.10059C34.6031 4.10059 37.1011 5.10059 37.8129 5.94165C38.5247 6.78271 38.9008 9.40522 38.9008 9.40522C38.9008 9.40522 35.6708 7.54429 34.6031 4.10721V4.10059Z",
    fill: "#BDBEBC"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5996 6.36249C35.5996 6.36249 35.8817 6.17706 36.3316 6.87905C36.7882 7.58103 36.4927 7.52143 36.4927 7.52143C36.4927 7.52143 35.8951 7.65388 35.5996 6.36249Z",
    fill: "#ACADAA"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 2.09249C19.5312 2.09249 19.2828 1.56269 20.2564 1.46335C21.2301 1.36401 21.6196 1.82097 21.6196 1.82097C21.6196 1.82097 21.6867 2.26467 19.5379 2.09249H19.5312Z",
    fill: "#ACADAA"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1645 35.8674C38.6205 35.7482 37.9692 36.8343 38.4191 37.6489C38.8623 38.4568 40.4 36.1323 39.1645 35.8674Z",
    fill: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3912 36.6591C38.3912 37.2816 39.1903 37.2551 39.4656 36.9107C39.7476 36.5597 39.6737 35.8313 39.0895 35.8644C38.4986 35.8975 38.3912 36.6591 38.3912 36.6591Z",
    fill: "#80807F"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.278 37.1992C38.419 36.815 38.9227 37.2323 39.2114 37.2323C39.5001 37.2323 39.057 37.8746 38.7212 37.815C38.3855 37.7488 38.278 37.1992 38.278 37.1992Z",
    fill: "#7F807E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19495 27.412C8.69132 27.6372 8.81891 28.8888 9.67171 29.2796C10.5111 29.6703 10.3499 26.8954 9.19495 27.412Z",
    fill: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05443 28.4912C9.43047 28.9879 10.055 28.5044 10.0684 28.0607C10.0818 27.617 9.58492 27.0674 9.13501 27.4382C8.67839 27.8091 9.05443 28.4912 9.05443 28.4912Z",
    fill: "#80807F"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M9.28889 29C9.16802 28.6092 9.82609 28.649 10.0544 28.4768C10.2827 28.3046 10.3163 29.0861 10.0141 29.2318C9.70522 29.3775 9.28889 29 9.28889 29Z",
    fill: "#7F807E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1726 38.3891C13.1726 38.3891 19.2296 42.6077 25.7767 42.4819C32.3305 42.356 37.9913 38.1309 37.9913 38.1309C37.9913 38.1309 33.9153 43.0713 26.2669 43.813C18.6185 44.5547 13.1659 38.3891 13.1659 38.3891H13.1726Z",
    fill: "#7F807E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7796 13.6559C16.7796 13.6559 19.1433 11.4109 23.1723 10.7619C27.2013 10.1129 30.1626 12.0334 30.1626 12.0334C30.1626 12.0334 28.0474 10.8678 23.4745 11.5367C18.9015 12.2056 16.7863 13.6559 16.7863 13.6559H16.7796Z",
    fill: "#ACADAA"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M28.596 43.5414C28.596 43.5414 28.8579 42.7203 30.9194 41.7931C32.9809 40.866 35.5058 40.3428 35.5058 40.3428C35.5058 40.3428 31.7252 43.2501 28.596 43.5481V43.5414Z",
    fill: "#ACADAA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1493 40.3395L32.9597 39.9355C28.5949 41.9422 25.5799 41.7965 25.5799 41.7965C25.5799 41.7965 22.0008 42.2071 18.2001 39.9355L15.0104 40.3395C15.0104 40.3395 16.4676 47.8826 17.1928 48.6243C17.1928 48.6243 21.665 49.5581 25.7813 49.5581C29.8976 49.5581 34.6049 48.5051 34.6049 48.5051C34.9675 47.3991 36.1493 40.3461 36.1493 40.3461V40.3395Z",
    fill: "url(#paint17_linear_4655_315159)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2001 39.9355C18.2001 39.9355 22.7797 41.7965 25.5799 41.7965C28.38 41.7965 32.9597 39.9355 32.9597 39.9355L36.1493 40.3395C36.1493 40.3395 31.2339 42.1872 25.7746 42.1872C20.3153 42.1872 15.0104 40.3395 15.0104 40.3395L18.2001 39.9355Z",
    fill: "#7F807E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7843 42.4121C16.7843 42.4121 28.2334 43.6902 34.9014 41.9419C34.9014 41.9419 34.6866 45.8161 34.1897 47.7167C34.1897 47.7167 27.4276 50.0015 17.8117 47.8889C17.8117 47.8889 16.7776 45.0412 16.7843 42.4121Z",
    fill: "url(#paint18_linear_4655_315159)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3685 42.707C17.3685 42.707 28.0857 43.8594 34.3239 42.2832C34.3239 42.2832 34.1225 45.7666 33.6592 47.4686C33.6592 47.4686 27.3336 49.5216 18.3355 47.6276C18.3355 47.6276 17.3685 45.0713 17.3752 42.707H17.3685Z",
    fill: "#1B1B1B"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7738 42.1842C25.7738 42.1842 28.5538 41.4226 30.0043 41.0584C31.4547 40.6942 35.2823 40.6279 35.2823 40.6279C35.2823 40.6279 30.3803 42.171 25.7738 42.1842Z",
    fill: "#ACADAA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8363 48.7657C26.8363 48.7657 27.6689 48.5736 29.5021 48.2425C31.3353 47.918 33.3968 47.9312 33.3968 47.9312C33.3968 47.9312 30.3415 48.673 26.8363 48.7657Z",
    fill: "#ACADAA"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0215 33.2261C10.0215 33.2261 10.4849 34.7824 11.5123 36.2195C11.5123 36.2195 10.9281 34.63 10.0215 33.2261Z",
    fill: "#ACADAA"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M8.57892 37.5548C8.57892 37.5548 10.9896 37.1972 12.346 37.9654C13.7025 38.7336 15.2671 41.5945 15.2671 41.5945L15.9184 44.5747C15.9184 44.5747 11.4865 42.1707 8.5722 37.5548H8.57892Z",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5123 44.2835C35.5123 44.2835 36.1099 40.8795 36.3785 40.3365C36.6471 39.7868 41.7304 37.4292 41.7304 37.4292C41.7304 37.4292 39.3465 41.1643 38.44 42.1842C37.5335 43.204 35.5056 44.2901 35.5056 44.2901L35.5123 44.2835Z",
    fill: "#232323"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93769 30.8939C4.93769 30.8939 4.76981 30.0396 5.09885 29.4833C5.42788 28.927 6.50229 28.6157 6.50229 28.6157L4.9444 30.8939H4.93769Z",
    fill: "#DBDCD8"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5491 28.6114C44.5491 28.6114 45.3885 28.5783 45.8182 29.0154C46.248 29.4525 46.0466 31.1147 46.0466 31.1147L44.5491 28.6114Z",
    fill: "#DBDCD8"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M13.8037 10.0553C15.7779 8.67119 18.0543 8.47914 18.887 9.63808C19.7196 10.7904 18.7929 12.8566 16.8187 14.2407C14.8445 15.6248 12.5681 15.8169 11.7355 14.6579C10.9028 13.5056 11.8295 11.4394 13.8037 10.0553Z",
    fill: "url(#paint19_radial_4655_315159)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M33.682 8.40609C35.5555 7.08821 38.1542 7.52529 39.4905 9.37298C40.8267 11.2207 40.3836 13.7836 38.5101 15.1015C36.6366 16.4193 34.0379 15.9822 32.7016 14.1346C31.3653 12.2869 31.8085 9.72397 33.682 8.40609Z",
    fill: "url(#paint20_radial_4655_315159)"
  }), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6485 33.0795H21.4039V20.4565H23.6485V33.0795Z",
    fill: "#E1E1E1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4024 33.0795H27.1579V20.4565H29.4024V33.0795Z",
    fill: "#E1E1E1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4655_315159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.353 25.3426) scale(25 24.6556)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "transparent",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#DDE0FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#CFD0FF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#8F93A8",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#42414F",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "transparent",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4655_315159",
    x1: 25.467,
    y1: 47.0016,
    x2: 25.467,
    y2: 8.18701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4655_315159",
    x1: 25.4685,
    y1: 43.832,
    x2: 25.4685,
    y2: 11.3618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4655_315159",
    x1: 15.012,
    y1: 26.3046,
    x2: 15.012,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4655_315159",
    x1: 14.5058,
    y1: 14.3976,
    x2: 14.5058,
    y2: 7.84131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#898A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4655_315159",
    x1: 22.652,
    y1: 8.50549,
    x2: 22.652,
    y2: 1.58496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4655_315159",
    x1: 15.1403,
    y1: 13.597,
    x2: 13.9362,
    y2: 9.21093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4655_315159",
    x1: 7.93476,
    y1: 22.8931,
    x2: 7.93476,
    y2: 15.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4655_315159",
    x1: 35.8952,
    y1: 26.3041,
    x2: 35.8952,
    y2: -0.000488281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4655_315159",
    x1: 36.399,
    y1: 14.3976,
    x2: 36.399,
    y2: 7.84131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDBEBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#898A88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4655_315159",
    x1: 28.2536,
    y1: 8.50549,
    x2: 28.2536,
    y2: 1.58496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4655_315159",
    x1: 35.7675,
    y1: 13.597,
    x2: 36.9716,
    y2: 9.21093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4655_315159",
    x1: 42.9734,
    y1: 22.8931,
    x2: 42.9734,
    y2: 15.3037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4655_315159",
    x1: 44.5514,
    y1: 36.0757,
    x2: 44.5514,
    y2: 21.5459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4655_315159",
    x1: 46.5947,
    y1: 30.9573,
    x2: 45.5935,
    y2: 27.3209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4655_315159",
    x1: 6.38371,
    y1: 36.0752,
    x2: 6.38371,
    y2: 21.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4655_315159",
    x1: 4.34927,
    y1: 30.9578,
    x2: 5.34397,
    y2: 27.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6C7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D6D4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4655_315159",
    x1: 25.5799,
    y1: 49.5581,
    x2: 25.5799,
    y2: 39.9355,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C9C9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4655_315159",
    x1: 25.8429,
    y1: 48.783,
    x2: 25.8429,
    y2: 41.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F807D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141414"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_4655_315159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.0459 11.9556) rotate(-125.806) scale(2.58591 4.36005)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B6B7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7F807E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#515251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_4655_315159",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5191 9.82759) rotate(-125.806) scale(4.11547 4.13388)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D6D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B6B7B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#7F807E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#515251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#2E2E2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#141414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#050505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4655_315159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.350647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverLeague);
export default __webpack_public_path__ + "static/media/silver-league.490dffce4f495089d9701c222f8de34f.svg";
export { ForwardRef as ReactComponent };